var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPurple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#C9BEFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.1143 30L45.3143 22.8C46.2286 21.8857 46.2286 20.5143 45.3143 19.6L40.5143 14.8C39.6 13.8857 38.2286 13.8857 37.3143 14.8L30 21.8857L22.8 14.6857C21.8857 13.7714 20.5143 13.7714 19.6 14.6857L14.6857 19.4857C13.7714 20.4 13.7714 21.7714 14.6857 22.6857L21.8857 30L14 37.8857V46H22.1143L30 38.1143L37.2 45.3143C38.1143 46.2286 39.4857 46.2286 40.4 45.3143L45.2 40.5143C46.1143 39.6 46.1143 38.2286 45.2 37.3143L38.1143 30ZM38.9143 16.2857L43.7143 21.0857L36.5143 28.2857L31.7143 23.4857L38.9143 16.2857ZM21.0857 43.7143H16.2857V38.9143L23.4857 31.7143L28.2857 36.5143L21.0857 43.7143ZM38.9143 43.7143L16.2857 21.0857L21.0857 16.2857L25.0857 20.2857L22.6857 22.6857L24.2857 24.2857L26.6857 21.8857L31.4857 26.6857L29.0857 29.0857L30.6857 30.6857L33.0857 28.2857L37.8857 33.0857L35.7143 35.6L37.3143 37.2L39.7143 34.8L43.7143 38.8L38.9143 43.7143Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurple);
export default __webpack_public_path__ + "static/media/purple.72561259f0ac49ffd636633e5bf5b9a0.svg";
export { ForwardRef as ReactComponent };